import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllFavoriteList } from '../../redux/Slices/FavoriteSlice'

const UseGetAllFavorite = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [allFavorites, setAllFavorite] = useState()
    const [favList, setFavList] = useState([])
    const { getAllFavoriteProducts } = useSelector(state => state.FavoriteReducer)

    // handle get all favorite products
    const handleGetAllFavoriteProducts = async () => {
        setLoading(true)
        await dispatch(getAllFavoriteList())
        setLoading(false)
    }

    // to run get all favorite products
    useEffect(() => {
        handleGetAllFavoriteProducts()
    }, [])

    // to handle the get all favorite products request response
    useEffect(() => {
        if (loading === false) {
            if (getAllFavoriteProducts && getAllFavoriteProducts.data) {
                setFavList(getAllFavoriteProducts.data.data.map(item => item._id))
                setAllFavorite(getAllFavoriteProducts.data.data)
            }
        }
    }, [loading])
    
    return [favList, allFavorites,loading]
}

export default UseGetAllFavorite
